import Navbar from "@/components/landing/Navbar";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import LeadDialog from "@/components/landing/LeadDialog";
import { useState } from "react";

export default function Landing() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadContext, setLeadContext] = useState({ plan: "", title: "Book a Free Consultation" });

  const openLead = (plan = "", title = "Book a Free Consultation") => {
    setLeadContext({ plan, title });
    setLeadOpen(true);
  };

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-slate-950 text-slate-100" data-testid="landing-root">
      <div className="fixed inset-x-0 top-0 z-50">
        <AnnouncementBar onClick={() => openLead("", "Claim your free leads")} />
        <Navbar onCTA={() => openLead("", "Get Started with Markite")} />
      </div>
      {/* Spacer to offset fixed header (announcement ~42px + navbar 64px) */}
      <div aria-hidden className="h-[106px]" />
      <main>
        <Hero onPrimary={() => openLead("", "Get Started with Markite")} />
        <Services />
        <Pricing onChoose={(plan) => openLead(plan, `Choose ${plan} plan`)} />
        <Testimonials />
        <FinalCTA onBook={() => openLead("", "Book a Free Consultation")} />
      </main>
      <Footer />
      <WhatsAppFloat />
      <LeadDialog
        open={leadOpen}
        onOpenChange={setLeadOpen}
        plan={leadContext.plan}
        title={leadContext.title}
        showOffer={!["Advanced", "Pro"].includes(leadContext.plan)}
      />
    </div>
  );
}
